import { useMutation, useQueryClient } from "@tanstack/react-query";

import useApiHelper from "../hooks/useApiHelper";
import apiConfig from "../utils/apiConfig";
import { IBulkPatchPartResponse, ScrapOut } from "../models/Part";

interface IBulkScrapOutRequest {
  partIds: string[];
  data: { scrapOut: ScrapOut };
}

/**
 * Puts a selection of parts in the yard app's Scrap Out queue through the existing bulk patch.
 * Nothing is scrapped or withdrawn here: an operator scans the tag in the app to confirm, and the
 * listing ends then. Same call as usePartMutations.sendToScrapOut, kept separate so the queue can
 * name what it is doing.
 */
export default function usePartBulkScrapOut(componentName = "usePartBulkScrapOut") {
  const { patch } = useApiHelper(apiConfig(componentName));
  const queryClient = useQueryClient();

  const bulkScrapOut = useMutation(
    (partIds: string[]) =>
      patch<IBulkPatchPartResponse>("/part/bulk", {
        partIds,
        data: { scrapOut: ScrapOut.Scrap },
      } as IBulkScrapOutRequest),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(["job"]);
        queryClient.invalidateQueries(["parts"]);
        queryClient.invalidateQueries(["partDetails"]);
        queryClient.invalidateQueries(["pagedTable"]);
        queryClient.invalidateQueries(["listingStats"]);
      },
    }
  );

  return {
    bulkScrapOut,
  };
}
